import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const GetCheckoutPageInputValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the checkout page to retrieve. You can get this from `create_checkout_page`, the dashboard, or another Checkout Page API response.',
  }),
});
